import { createRoutesFromElements, createBrowserRouter, createMemoryRouter } from 'react-router-dom';
import { ReactNode } from 'react';

const createRouter = (routes: ReactNode, initialEntries?: string[]) => {
  return import.meta.env.MODE === 'test'
    ? createMemoryRouter(createRoutesFromElements(routes), { initialEntries })
    : createBrowserRouter(createRoutesFromElements(routes));
};
export default createRouter;
